import { theme } from 'antd';
import { Col } from 'antd';
import React, { type ReactNode } from 'react';

import { SPACING } from '../theme/tokens';

type BubbleComponentProps = {
  children: ReactNode;
  span?: number;
};

function BubbleComponent({
  children,
  span = undefined,
}: BubbleComponentProps): React.ReactElement {
  const { token } = theme.useToken();

  return (
    <Col span={span}>
      <div
        style={{
          border: `1px solid ${token.colorBorderSecondary}`,
          padding: SPACING.sm,
          backgroundColor: token.colorFillAlter,
          borderRadius: '6px',
        }}
      >
        {children}
      </div>
    </Col>
  );
}

export default BubbleComponent;
